export const CLIENT_SIGNATURES = {
    FREE: 1,
    NEWS_REAL_TIME: 2,
    ANALISYS: 3,
    MARKET: 4,
    LIVE_CONSULTING: 5
};